import type { KeyboardEvent } from "react";

export function isPartyNameSubmitKey(e: KeyboardEvent): boolean {
  return e.key === "Enter" || e.key === "NumpadEnter";
}

/** Enter / NumpadEnter: prevent default and run action (e.g. add roster name). */
export function handlePartyRosterNameEnter(e: KeyboardEvent, action: () => void): void {
  if (!isPartyNameSubmitKey(e)) return;
  e.preventDefault();
  action();
}

/** Enter / NumpadEnter on first team field: move focus to the next field (Imposter-style flow for dual team names). */
export function handlePartyTeamNameEnterFocusNext(e: KeyboardEvent, next: HTMLElement | null | undefined): void {
  if (!isPartyNameSubmitKey(e)) return;
  e.preventDefault();
  next?.focus();
}
